import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M7.139 11.709l-.848-.848L2.2 14.952V10.8L1 12v5h5l1.2-1.2H3.048l4.091-4.091zm8.661 3.243l-4.091-4.09-.848.848 4.091 4.09H10.8L12 17h5v-5l-1.2-1.2v4.152zM12 1l-1.2 1.2h4.152l-4.09 4.09.848.848 4.09-4.09V7.2L17 6V1h-5zM1 1v5l1.2 1.2V3.048l4.091 4.09.848-.848L3.048 2.2H7.2L6 1H1z" />
  </svg>
);

export default SvgComponent;
